import { render, staticRenderFns } from "./AngryMiao021C.vue?vue&type=template&id=68a7f54d&scoped=true"
import script from "./AngryMiao021C.vue?vue&type=script&lang=ts"
export * from "./AngryMiao021C.vue?vue&type=script&lang=ts"
import style0 from "./AngryMiao021C.vue?vue&type=style&index=0&id=68a7f54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7f54d",
  null
  
)

export default component.exports